import {
  AnalyticsData,
  RegistrationTypes,
  Currency,
} from '@sportninja/common/types/Registration'
import { RegistrationData } from '@sportninja/common/hooks/useRegistrationData'
import { RegistrationTableDivision } from '../../types'

export enum ActionType {
  SET_LOADING = 'SET_LOADING',
  SET_LOADING_ANALYTICS = 'SET_LOADING_ANALYTICS',
  SET_LOADING_TYPES = 'SET_LOADING_TYPES',
  SET_STATUS_UPDATE_LOADING = 'SET_STATUS_UPDATE_LOADING',
  SET_ERROR = 'SET_ERROR',
  SET_DATA = 'SET_DATA',
  SET_ANALYTICS = 'SET_ANALYTICS',
  SET_TYPES = 'SET_TYPES',
  SET_DIVISIONS = 'SET_DIVISIONS',
}

export interface LoadingState {
  fetch: boolean
  analytics: boolean
  types: boolean
  statusUpdate: Set<string>
}

export interface RegistrationState {
  data: RegistrationData | null
  types: RegistrationTypes | null
  analytics: AnalyticsData | null
  divisions: RegistrationTableDivision[]
  loading: LoadingState
  error: Error | null
  scheduleId: string
  isPlayerRegistrationEnabled: boolean
  isTeamRegistrationEnabled: boolean
  showWaiver: boolean
  currency: Currency
  isRegistrationEmpty: boolean
}

export type RegistrationAction =
  | { type: ActionType.SET_LOADING; payload: boolean }
  | { type: ActionType.SET_LOADING_ANALYTICS; payload: boolean }
  | { type: ActionType.SET_LOADING_TYPES; payload: boolean }
  | {
      type: ActionType.SET_STATUS_UPDATE_LOADING
      payload: { id: string; loading: boolean }
    }
  | { type: ActionType.SET_ERROR; payload: Error | null }
  | { type: ActionType.SET_DATA; payload: RegistrationData | null }
  | { type: ActionType.SET_ANALYTICS; payload: AnalyticsData | null }
  | { type: ActionType.SET_TYPES; payload: RegistrationTypes | null }
  | { type: ActionType.SET_DIVISIONS; payload: RegistrationTableDivision[] }

export interface RefetchOptions {
  displayLoading?: boolean
  onBeforeFetch?: () => void
  onAfterFetch?: () => void
}

export interface RegistrationContextValue extends RegistrationState {
  refetch: (options?: boolean | RefetchOptions) => Promise<void>
  refetchAnalytics: () => Promise<void>
  updateTeamStatus: (params: UpdateTeamStatusParams) => Promise<void>
  updatePlayerStatus: (params: UpdatePlayerStatusParams) => Promise<void>
}

export interface UpdateTeamStatusParams {
  teamRegistrationId: string
  status: number
  divisionId?: string
  conditions?: string | null
  conditionType?: number | null
  refundAllFunds?: boolean
  /** Callback to capture scroll position before refetch */
  onBeforeRefetch?: () => void
  /** Callback to restore scroll position after refetch */
  onAfterRefetch?: () => void
}

export interface UpdatePlayerStatusParams {
  teamRegistrationId: string
  status: number
  divisionId?: string
  conditions?: string | null
  conditionType?: number | null
  refundAllFunds?: boolean
  /** Callback to capture scroll position before refetch */
  onBeforeRefetch?: () => void
  /** Callback to restore scroll position after refetch */
  onAfterRefetch?: () => void
}
